// extracted by mini-css-extract-plugin
export var divider = "_xp-0";